import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Skeleton,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import { NoInfoComponent } from "../../NoInfoImage/noInfoComponent";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getUser, getUserStatus } from "../../../../pages/userSlice";
import { GetRolesByProduct } from "../../../../services/admin/adminServices";
import { CODES } from "../../../../consts/codes";
import { Key } from "@mui/icons-material";

const RolViewerModal = () => {
  /**
   * Title Container component
   */
  const DialogTitleContainer = (props) => {
    const { children, onClose, ...other } = props;

    return (
      <DialogTitle {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  /**
   * useTranslation
   */
  const { t } = useTranslation();

  /**
   * Use State
   */
  const userInfo = useSelector(getUser);
  const userStatus = useSelector(getUserStatus);

  const [openRoleViewer, setOpenRoleViewer] = useState(false);

  const [data, setData] = useState([]);
  const [isLoadingData, setIsLoadingData] = useState(false);

  /**
   * Carga los roles
   */
  useEffect(() => {
    if (userStatus === "succeeded") fetchRolesByIdMenuOption();
  }, [userStatus]);

  /**
   * Función que trae la lista de roles según el idMenuOption
   *
   */
  const fetchRolesByIdMenuOption = async () => {
    const idMenuOption = userInfo?.lstMenu ? userInfo?.lstMenu[0]?.pk : "";

    try {
      setIsLoadingData(true);

      const {
        status,
        data: { responseCode, responseMessage },
      } = await GetRolesByProduct({
        idMenuOption: idMenuOption.split("#")[1],
        isClient: true,
      });

      if (
        status === CODES.COD_RESPONSE_HTTP_OK &&
        responseCode === CODES.COD_RESPONSE_SUCCESS_REQUEST
      ) {
        setData(responseMessage);
        return responseMessage;
      }
    } catch (error) {
      console.log("====================================");
      console.log(error);
      console.log("====================================");
    } finally {
      setIsLoadingData(false);
    }
  };

  /**
   * Handles
   */

  /**
   * Función que abre el modal
   */
  const handleOpen = () => {
    setOpenRoleViewer(true);
  };

  /**
   * Función para cerrar el modal
   */
  const handleClose = async () => {
    setOpenRoleViewer(false);
  };

  // Table
  const columns = [
    {
      name: "nameRole",
      label: t("App.infonavitUsers.rolesModal.table.role"),
      options: {
        filter: false,
        sort: true,
        searchable: false,
      },
    },
    {
      name: "descriptionRole",
      label: t("App.infonavitUsers.rolesModal.table.description"),
      options: {
        filter: false,
        sort: true,
        searchable: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value.split("\\n").length > 1 ? (
            <ul>
              {value.split("\\n").map((p, key) => {
                return <li key={`${tableMeta.columnIndex}${key}`}>{p}</li>;
              })}
            </ul>
          ) : (
            value
          );
        },
      },
    },
  ];

  const options = {
    selectToolbarPlacement: "none",
    print: "false",
    filter: false,
    download: false,
    search: false,
    pagination: false,
    selectableRows: "none",
    responsive: "standard",
    elevation: 0,
    viewColumns: false,
    textLabels: {
      body: {
        noMatch: isLoadingData ? (
          <Skeleton />
        ) : (
          <NoInfoComponent type="dynamic" text="" />
        ),
        toolTip: "Sort",

        columnHeaderTooltip: (column) =>
          t("App.buttonLabels.order", { label: column.label }),
      },
    },
  };

  return (
    <>
      <Button
        startIcon={<VisibilityOutlinedIcon sx={{ fontSize: 22 }} />}
        className="btn__outlined__blue__new"
        onClick={handleOpen}
      >
        {t("App.infonavitUsers.rolesBtn")}
      </Button>

      <Dialog
        onClose={handleClose}
        open={openRoleViewer}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              height: "100%",
              maxWidth: "900px",
              maxHeight: "39rem",
              boxShadow: "none",
              borderRadius: "22px",
              padding: "2rem",
              overflow: "hidden",
            },
          },
        }}
      >
        <DialogTitleContainer onClose={handleClose}>
          <Grid container direction="column" rowSpacing={1}>
            <Grid item className="display-large__primary-one">
              {t("App.infonavitUsers.rolesModal.title")}
            </Grid>
          </Grid>
        </DialogTitleContainer>

        <DialogContent className="scroll-table">
          <MUIDataTable
            className="dataTable__base datatable-style dataTable__auto-height"
            data={data}
            columns={columns}
            options={options}
            components={{
              TableToolbar(props) {
                return null;
              },
            }}
          />
        </DialogContent>

        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RolViewerModal;
